import React, { Component } from "react";
import { setMenuTopIndex, setMenuLeftContent } from "./../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import AuthRender from "../containers/AuthRender";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("");
    this.props.setMenuLeftContent({ display: false, content: [] });
  }

  render() {
    return (
      <div className="p-al-r-full-center p-home">
        {/*
					<div>
					<div>Les accès sont géré par client de façons automatiques</div>
						<AuthRender minRole={1}>
							<div>Seulement les admins</div>
						</AuthRender>
						<AuthRender minRole={3}>
							<div>Seulement les admins, directeur et managers</div>
						</AuthRender>
						<AuthRender roles={[2, 4]}>
							<div>Seulement les directeurs et CS</div>
						</AuthRender>
						<AuthRender service={1}>
							<div>Tous les utilisateurs qui ont au moins 1 accès au service 1</div>
						</AuthRender>
						<AuthRender service={1} access={["consultation"]}>
							<div>Tous les utilisateurs qui ont l'accès consultation pour le service 1</div>
						</AuthRender>
						<AuthRender service={1} access={["consultation", "export"]}>
							<div>Tous les utilisateurs qui ont l'accès consultation ET export, pour le service 1</div>
						</AuthRender>
						<AuthRender minRole={3} service={1} access={["consultation", "export"]}>
							<div>Tous les utilisateurs avec le role ADMIN, DIR, MANAGER, qui ont l'accès consultation ET export, pour le service 1</div>
						</AuthRender>
						<AuthRender  service={1} forbidden_access={["export"]}>
							<div>Tous les utilisateurs qui n'ont PAS accès aux service d'export</div>
						</AuthRender>
					</div>
					*/}
        <img src="img/efficience.png" />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftContent: data => {
      dispatch(setMenuLeftContent(data));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/Home.js